import { Building2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import Panel from './Panel';

const jobCountLabel = (n) => `${n} ${n === 1 ? 'job' : 'jobs'}`;

const CompaniesPanel = ({ companies, jobs, onNavigate }) => {
  const countFor = (company) => jobs.filter((j) => j.companyId === company.id || j.companyName === company.name).length;
  return (
    <Panel title="My Companies" onViewAll={() => onNavigate('/companies')} testId="my-companies">
      {companies.length === 0 ? (
        <div className="text-center py-6" data-testid="empty-companies">
          <Building2 className="w-8 h-8 mx-auto mb-3 text-muted-foreground" />
          <p className="text-sm text-muted-foreground mb-4">No companies added yet</p>
          <Button size="sm" onClick={() => onNavigate('/companies/add')}>Add Your First Company</Button>
        </div>
      ) : (
        <ul className="divide-y divide-border">
          {companies.slice(0, 4).map((company) => (
            <li key={company.id || company.name} className="flex items-center justify-between gap-3 py-3 first:pt-0 last:pb-0">
              <div className="flex items-center gap-3 min-w-0">
                <Building2 className="w-5 h-5 shrink-0 text-muted-foreground" />
                <div className="min-w-0">
                  <p className="text-sm font-medium truncate">{company.name}</p>
                  <p className="text-xs font-mono text-muted-foreground">{company.registrationNumber}</p>
                </div>
              </div>
              <span className="text-sm text-muted-foreground shrink-0">{jobCountLabel(countFor(company))}</span>
            </li>
          ))}
        </ul>
      )}
    </Panel>
  );
};

export default CompaniesPanel;
